// eslint-disable-next-line no-unused-vars
import styled, { css } from 'styled-components';

import {
    Text,
    TextButton,
    spaceMixin,
} from '@zillow/constellation';

export const StyledCompsComponent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 3;
    padding: 15px 0;
    text-align: left;
`;

export const StyledCompsSummaryContainer = styled.div`
    /* align center until map is implemented */
    text-align: center;
    margin-bottom: ${spaceMixin('sm')};
`;

export const StyledText = styled(Text)``;

export const StyledTextButton = styled(TextButton)`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-self: center;
    text-decoration: none;

    .TextButton-Content {
        margin-right: ${spaceMixin('xs')};
        /* helps vertically center */
        line-height: 17px;
    }

    .TextButton-Icon {
        display: inline-flex;
    }

    &:hover {
        text-decoration: none;
    }
`;
